import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui/box';
import type { BoxProps } from 'components/ui/box';
import { Typography } from 'components/ui/typography';
import type { TypographyProps } from 'components/ui/typography';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const Inner = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.inner, style] });

export const Header = ({ style, ...props }: TypographyProps) => {
  const isDesktopWebBreakpoint = useIsDesktopWebBreakpoint();

  return React.createElement(Typography, {
    ...props,
    style: [styles.header, isDesktopWebBreakpoint && styles.desktopHeader, style],
    variant: 'headerOne',
  });
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    bottom: 0,
    flex: 1,
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  header: {
    marginVertical: spacing.$5,
    maxWidth: '75%',
    textAlign: 'center',
    textTransform: getDesignToken('text-transform-headlines'),
  },
  desktopHeader: {
    maxWidth: 500,
  },
  inner: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.$8,
  },
});
